import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import ContentNotFoundImage from '../../../../../../assets/images/content-not-found.inline.svg';
import * as classes from './ContentNotFoundSection.module.scss';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const ContentNotFoundSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Section number={'01'} label={t('additionalInfo.contentNotFoundSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12'>
            <SectionTitle>{t('additionalInfo.contentNotFoundSection.titleText')}</SectionTitle>
          </div>
          <div className='col-xl-7 col-lg-7 col-md-6 col-sm-12'>
            <div className={classes.imageWrapper}>
              <ContentNotFoundImage />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default ContentNotFoundSection;
